export const BASE_API = `https://stock-overfloww.herokuapp.com`;
// export const BASE_API = `http://localhost:8081`;
export const FINANCYY_API = `https://tube-stox.herokuapp.com`;
export const CLOUDINARY_API = `https://api.cloudinary.com/v1_1/dmk11fqw8/upload`;
